export const FETCH_PATIENTS_BY_SEARCH = "[RECEPTIONIST] FETCH_PATIENTS_BY_SEARCH";
export const FETCH_PATIENTS_BY_SEARCH_START = "[RECEPTIONIST] FETCH_PATIENTS_BY_SEARCH_START";
export const FETCH_PATIENTS_BY_SEARCH_SUCCESS = "[RECEPTIONIST] FETCH_PATIENTS_BY_SEARCH_SUCCESS";
export const FETCH_PATIENTS_BY_SEARCH_ERROR = "[RECEPTIONIST] FETCH_PATIENTS_BY_SEARCH_ERROR";
export const ADD_NEW_PATIENT = "[RECEPTIONIST] ADD_NEW_PATIENT";
export const ADD_NEW_PATIENT_START = "[RECEPTIONIST] ADD_NEW_PATIENT_START";
export const ADD_NEW_PATIENT_SUCCESS = "[RECEPTIONIST] ADD_NEW_PATIENT_SUCCESS";
export const ADD_NEW_PATIENT_ERROR = "[RECEPTIONIST] ADD_NEW_PATIENT_ERROR";
export const UPDATE_PATIENT = "[RECEPTIONIST] UPDATE_PATIENT";
export const UPDATE_PATIENT_START = "[RECEPTIONIST] UPDATE_PATIENT_START";
export const UPDATE_PATIENT_SUCCESS = "[RECEPTIONIST] UPDATE_PATIENT_SUCCESS";
export const UPDATE_PATIENT_ERROR = "[RECEPTIONIST] UPDATE_PATIENT_ERROR";
export const UPLOAD_PATIENT_DOCUMENT = "[RECEPTIONIST] UPLOAD_PATIENT_DOCUMENT";
export const UPLOAD_PATIENT_DOCUMENT_SUCCESS = "[RECEPTIONIST] UPLOAD_PATIENT_DOCUMENT_SUCCESS";
export const UPLOAD_PATIENT_DOCUMENT_ERROR = "[RECEPTIONIST] UPLOAD_PATIENT_DOCUMENT_ERROR";
export const FETCH_PATIENT_DOCUMENTS = "[RECEPTIONIST] FETCH_PATIENT_DOCUMENTS";
export const FETCH_PATIENT_DOCUMENTS_SUCCESS = "[RECEPTIONIST] FETCH_PATIENT_DOCUMENTS_SUCCESS";
export const FETCH_PATIENT_DOCUMENTS_ERROR = "[RECEPTIONIST] FETCH_PATIENT_DOCUMENTS_ERROR";

export const MERGE_PATIENTS = "[RECEPTIONIST] MERGE_PATIENTS";
export const MERGE_PATIENTS_SUCCESS = "[RECEPTIONIST] MERGE_PATIENTS_SUCCESS";
export const MERGE_PATIENTS_ERROR = "[RECEPTIONIST] MERGE_PATIENTS_ERROR";
export const REMOVE_MERGE_PATIENTS = "[RECEPTIONIST] REMOVE_MERGE_PATIENTS";

export const FETCH_PATIENT_NOTES = "[RECEPTIONIST] FETCH_PATIENT_NOTES";
export const FETCH_PATIENT_NOTES_SUCCESS = "[RECEPTIONIST] FETCH_PATIENT_NOTES_SUCCESS";
export const FETCH_PATIENT_NOTES_ERROR = "[RECEPTIONIST] FETCH_PATIENT_NOTEES_ERROR";

export const ADD_UPDATE_PATIENT_NOTES = "[RECEPTIONIST] ADD_UPDATE_PATIENT_NOTES";
export const ADD_UPDATE_PATIENT_NOTES_SUCCESS = "[RECEPTIONIST] ADD_UPDATE_PATIENT_NOTES_SUCCESS";
export const ADD_UPDATE_PATIENT_NOTES_ERROR = "[RECEPTIONIST] ADD_UPDATE_PATIENT_NOTES_ERROR";

export const DELETE_PATIENT_DOCUMENT = "[RECEPTIONIST] DELETE_PATIENT_DOCUMENT";
export const DELETE_PATIENT_DOCUMENT_SUCCESS = "[RECEPTIONIST] DELETE_PATIENT_DOCUMENT_SUCCESS";
export const DELETE_PATIENT_DOCUMENT_ERROR = "[RECEPTIONIST] DELETE_PATIENT_DOCUMENT_ERROR";

export const SET_SELECTED_PATIENT = "[RECEPTIONIST] SET_SELECTED_PATIENT";
export const SET_SELECTED_PATIENT_SUCCESS = "[RECEPTIONIST] SET_SELECTED_PATIENT_SUCCESS";
export const SET_SELECTED_PATIENT_ERROR = "[RECEPTIONIST] SET_SELECTED_PATIENT_ERROR";

export const RESET_SELECTED_PATIENT = "[RECEPTIONIST] RESET_SELECTED_PATIENT";

export const fetchPatientsBySearch = (searchObj) => {
    return {
        type: FETCH_PATIENTS_BY_SEARCH,
        payload: { searchObj }
    }
}

export const addNewPatient = (patient, resolve) => {
    return {
        type: ADD_NEW_PATIENT,
        payload: { patient, resolve }
    }
}
export const updatePatient = (patient, resolve) => {
    return {
        type: UPDATE_PATIENT,
        payload: { patient, resolve }
    }
}

export const mergePatients = (toBeDeletedPatientId , retainedPatientId , resolve) => {
    return {
        type: MERGE_PATIENTS,
        payload: { toBeDeletedPatientId, retainedPatientId, resolve }
    }
}

export const uploadPatientDocuments = (documents, patientId) => {
    return {
        type: UPLOAD_PATIENT_DOCUMENT,
        payload: { documents, patientId }
    }
}

export const fetchPatientDocuments = (patientId) => {
    return {
        type: FETCH_PATIENT_DOCUMENTS,
        payload: { patientId }
    }
}

export const fetchPatientNotes = (patientId) => {
    return {
        type: FETCH_PATIENT_NOTES,
        payload: { patientId }
    }
}

export const addUpdatePatientNotes = (notes, resolve) => {
    return {
        type: ADD_UPDATE_PATIENT_NOTES,
        payload: { notes, resolve }
    }
}

export const deletePatientDocument = (documentId, patientId, resolve) => {
    return {
        type: DELETE_PATIENT_DOCUMENT,
        payload: { documentId, patientId, resolve }
    }
}

export const setSelectedPatient = (patient,visitId) => {
    return {
        type: SET_SELECTED_PATIENT,
        payload: { patient, visitId }
    }
}

export const setSelectedPatientSuccess = (patient) => {
    return {
        type: SET_SELECTED_PATIENT_SUCCESS,
        patient
    }
}

export const resetSelectedPatient = () => {
    return {
        type: RESET_SELECTED_PATIENT
    }
}